"use strict";

angular.module("core")
.service("Language", function(gettextCatalog, $rootScope, $http, $resource, moment, UserService, appConfig) {
    var preferred_locale = [
        "en_US",
        "fr_CA",
        "es_MX"
    ];
    var supported_locale = {
        en_US: "en",
        fr_CA: "fr",
        es_MX: "es"
    };
    var current_locale = Object.keys(supported_locale)[1];
    var current_language = supported_locale[current_locale];
    var instance = this;
    var initialized = false;
    $rootScope.languages = [];

    this.getLanguages = function() {
        return $http.get(appConfig.API_SERVER + "/auth/language/", {
            withCredentials: false,
            disableTokenForRequest: true
        }).then(function(response) {
            return response;
        });
    };

    this.getLanguages().then(function(response) {
        if (response.data) {
            $rootScope.languages = response.data;
            $rootScope.$broadcast("LanguagesFetched", $rootScope.languages);
        }
    });

    this.getValidLocale = function(locale) {
        locale = locale.replace("-", "_");
        if (supported_locale.hasOwnProperty(locale)) {
            return locale;
        }
        var temp_locale = this.getLocaleFromLanguage(locale);
        if (temp_locale) {
            return temp_locale;
        }
        return current_locale;
    };

    this.getLocaleFromLanguage = function(language) {
        var locale;
        angular.forEach(supported_locale, function(value, key) {
            if (value === language) {
                locale = key;
            }
        });
        return locale;
    };

    this.init = function() {
        var unregisterUserUpdate = $rootScope.$on("UserUpdated", function(event, user) {
            unregisterUserUpdate();
            if (user && user.info.Language) {
                current_locale = instance.getLocaleFromLanguage(user.info.Language);
                instance.set(current_locale);
            }
        });
        var locale = (window.navigator.userLanguage)
            ? window.navigator.userLanguage : (window.navigator.languages && window.navigator.languages.length > 0)
                ? window.navigator.languages[0] : window.navigator.language;
        this.set(locale);

        // Adds language to gettextCatalog for locale display
        angular.forEach(supported_locale, function(value, key_locale) {
            angular.forEach(supported_locale, function(val, key) {
                var locale_object = {};
                locale_object[key] = supported_locale[key];
                gettextCatalog.setStrings(key_locale, locale_object);
            });
        });
        initialized = true;
    };

    this.getSupportedLocales = function() {
        return Object.keys(supported_locale);
    };

    this.getSupportedLanguages = function() {
        var languages = Array();
        angular.forEach(preferred_locale, function(value, key) {
            languages.push(supported_locale[value]);
        });
        return languages;
    };

    this.getLocale = function() {
        return current_locale;
    };

    this.getLanguage = function() {
        return supported_locale[current_locale];
    };

    this.set = function(locale, ignore_user_language) {
        current_locale = this.getValidLocale(locale);
        moment.locale(current_locale);
        gettextCatalog.setCurrentLanguage(current_locale);
        current_language = this.getLanguage();
        $rootScope.language = current_language;
        $rootScope.locale = current_locale;
        // Updates the user languages into the db
        if (initialized && UserService.isLoggedIn() && !ignore_user_language) {
            $http({
                method: "put",
                url: appConfig.API_SERVER + "/auth/language/edit/",
                params: {language: current_language},
                withCredentials: true
            }).then(function(data) {
                $rootScope.$broadcast("LanguageChanged", current_locale, current_language);
            });
        }
        else {
            $rootScope.$broadcast("LanguageChanged", current_locale, current_language);
        }
    };

    this.initializeScope = function(scope, language_field, locale_field) {
        setLanguageToObject(scope, language_field, locale_field, current_locale, current_language);
        scope.$on("LanguageChanged", function(evt, new_locale, new_language) {
            setLanguageToObject(scope, language_field, locale_field, new_locale, new_language);
        });
    };

    this.initializeController = function(controller, language_field, locale_field) {
        setLanguageToObject(controller, language_field, locale_field, current_locale, current_language);

        var unregister = $rootScope.$on("LanguageChanged", function(evt, new_locale, new_language) {
            setLanguageToObject(controller, language_field, locale_field, new_locale, new_language);
        });

        return unregister;
    };

    function setLanguageToObject(instance, language_field, locale_field, new_locale, new_language) {
        if (language_field) {
            instance[language_field] = new_language;
        }
        if (locale_field) {
            instance[locale_field] = new_locale;
        }
    }

})

.factory("languageInterceptor", function($injector) {
    return {
        request: function(config) {
            var language = $injector.get("Language");
            config.headers = config.headers || {};
            config.headers["Accept-Language"] = language.getLanguage();
            return config;
        }
    };
})

.config(["$httpProvider", function($httpProvider) {
    $httpProvider.interceptors.push("languageInterceptor");
}])

.filter("localizedField", function(Language) {
    function localizedField(value) {
        if (!value || typeof value !== "object")
            return "";
        var preferred_translation = value[Language.getLanguage()];
        if (preferred_translation) {
            return preferred_translation;
        }
        return "";
    }

    localizedField.$stateful = true;
    return localizedField;
});



//////////////////
// WEBPACK FOOTER
// ./core/language/language.service.js
// module id = 411
// module chunks = 0